/**
 * Auth store với auto-refresh wired vào api client.
 */
import { create } from "zustand";

import { authApi } from "@/api/auth";
import {
  setAuthClearer,
  setAuthTokenGetter,
  setAuthTokenSetter,
  setRefreshFn,
} from "@/api/client";
import type { User } from "@/types";

interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setAuth: (user: User, accessToken: string) => void;
  setToken: (accessToken: string | null) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isLoading: true,
  setAuth: (user, accessToken) =>
    set({ user, accessToken, isAuthenticated: true, isLoading: false }),
  setToken: (accessToken) => set({ accessToken }),
  clearAuth: () =>
    set({ user: null, accessToken: null, isAuthenticated: false, isLoading: false }),
}));

// Wire api client → auth store
setAuthTokenGetter(() => useAuthStore.getState().accessToken);
setAuthTokenSetter((token) => useAuthStore.getState().setToken(token));
setAuthClearer(() => useAuthStore.getState().clearAuth());
setRefreshFn(async () => {
  try {
    const tokens = await authApi.refresh();
    return tokens.access_token;
  } catch {
    return null;
  }
});
